"use client";
import React from "react";
/**
 * useZoomedDesktop
 * Returns true if the current device is a desktop (hover + fine pointer)
 * and the viewport is narrow enough to match a mobile breakpoint (e.g. due to zoom).
 */
export default function useZoomedDesktop(breakpoint = 1024) {
    const [isZoomed, setIsZoomed] = React.useState(false);
    React.useEffect(() => {
        function check() {
            const isDesktop = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
            const isSmallViewport = window.innerWidth < breakpoint && window.screen.width >= breakpoint;
            setIsZoomed(isDesktop && isSmallViewport);
        }
        check();
        window.addEventListener("resize", check);
        return () => window.removeEventListener("resize", check);
    }, [breakpoint]);
    return isZoomed;
}
